// extracted by mini-css-extract-plugin
var _1 = "IntegrationsBrandCell-modulelogo__XIEV0";
export { _1 as "logo" }
